<template>
    <div class="superbill-code-admin mt-page">

        <crud-table :title="`Manage Superbill Codes for ${practiceName}`"
                    item-table="superbill-code"
                    item-name="Code"
                    :new-item="newItem"
                    :filters="filters"
                    :display-fields="displayFields"
                    :edit-fields="editFields">
        </crud-table>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
    import Vue from 'vue'

    /**
     * Page for a Practitioner to manage SuperbillCodes for their Practice
     */
    export default Vue.extend({
        name: 'SuperbillCodeAdmin',
        props: {
            practiceId: Number,
        },
        data() {
            return {
                practiceName: '',
                newItem: {
                    practice_id: this.practiceId,
                    code: '',
                    description: '',
                    cost: 0,
                },
                filters: {
                    practice_id: { field: 'practice_id', type: 'hidden', value: this.practiceId },
                    code: {field: 'code', type: 'string', value: null, label: 'CPT Code'},
                    description: {field: 'description', type: 'string', value: null, label: 'Description'},
                },
                displayFields: [
                    {key: 'code', sortable: true},
                    {key: 'description', sortable: true},
                    {key: 'charge', sortable: true},
                ],
                editFields: [
                    {key: 'code', type: 'text', label: 'CPT Code'},
                    {key: 'description', type: 'text', label: 'Description'},
                    {key: 'charge', type: 'number', label: 'Charge'},
                ],
            }
        },
        mounted () {
            // load practice
            this.$api.getItem(this, 'practice', this.practiceId)
                .then((practice) => {
                    this.practiceName = practice.name
                })
        }

    })

</script>
